import { OrderSummaryMetaCountStatusType, OrderSummaryMetaType } from "@/types/orders";

export interface OrderSummaryMetaTypeInterface {
  count_payment_status: any;
  count_status: OrderSummaryMetaCountStatusType;
  sequence_number: number;
  isClosed: boolean;

  cardsCounts: any;
}

export class OrderStatusCount {
  CANCELED: number = 0;
  DRAFT: number = 0;
  OPENED: number = 0;
  PENDING: number = 0;
  REJECTED: number = 0;
  CLOSED: number = 0;
  constructor(data) {
    Object.assign(this, data);
  }
}

export class OrdersMeta implements OrderSummaryMetaTypeInterface {
  count_payment_status: any;
  count_status: OrderSummaryMetaCountStatusType;
  sequence_number: number;
  isClosed: boolean = false;

  constructor(data: OrderSummaryMetaType) {
    this.count_payment_status = data?.count_payment_status;
    this.count_status = new OrderStatusCount(data?.count_status);
    this.sequence_number = data?.sequence_number;
    this.isClosed = data?.isClosed;
  }

  /***
   * get the meta counts
   * @return {any}
   */
  get cardsCounts(): any {
    if (this.isClosed) {
      return {
        CLOSED: this.count_status.CLOSED,
      };
    }

    return {
      CANCELED: this.count_status.CANCELED,
      DRAFT: this.count_status.DRAFT,
      OPENED: this.count_status.OPENED,
      PENDING: this.count_status.PENDING,
      REJECTED: this.count_status.REJECTED,
    };
  }
}
